import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import ILUSTRACAO_VOO_CANCELADO from '../../images/canceled-flight.svg';

import Title from '../../components/Title';
import { colors } from '../../styles/colors';
import FlightSummary from '../../components/FlightSummary';
import FLIGHT_STATUS from '../../consts/FLIGHT_STATUS';
import Button from '../../components/Button';
import { devices } from '../../styles/breakpoints';
// import { flights } from '../../consts/MOCK_DATA';

const FlightChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;

  @media ${devices.desktop} {
    max-width: 1170px;
    margin: 0 auto;
  }
`;

const IllustrationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 12px;

  @media ${devices.desktop} {
    display: none;
  }
`;

const Illustration = styled.img`
  width: 134px;
  height: 134px;

  @media ${devices.desktop} {
    width: 230px;
    height: 230px;
  }
`;

const TextForUser = styled.p`
  color: ${colors.GRAY_DARKEST};
  font-size: 14px;

  @media ${devices.desktop} {
    font-size: 20px;
    line-height: 24px;

    ${({ hasSuggestion, center }) =>
      !hasSuggestion &&
      center &&
      css`
        margin: 0 auto;
        max-width: 640px;
        text-align: center;
      `}
  }
`;

const BoldText = styled.span`
  color: ${colors.GRAY_DARKEST};
  font-size: inherit;
  font-weight: bold;
`;

const ReservationCode = styled(BoldText)`
  margin-bottom: 8px;

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const BigBlueText = styled.p`
  margin-top: 26px;
  margin-bottom: 12px;
  font-size: 14px;
  color: ${colors.BRAND_PRIMARY};

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const ActionsContainer = styled.div`
  ${({ hasSuggestion, center }) =>
    hasSuggestion
      ? css`
          margin-top: 12px;

          @media ${devices.desktop} {
            display: flex;
            justify-content: space-between;
            width: 600px;

            ${Button} {
              flex-basis: 48%;
            }
          }
        `
      : css`
          position: fixed;
          bottom: 0px;
          width: calc(100% - 32px);
          left: 0px;
          margin-left: 16px;

          @media ${devices.desktop} {
            position: relative;
            width: 340px;
            margin: 0;

            ${center &&
            css`
              margin: 0 auto;
            `}
          }
        `}
`;

const Username = styled.span`
  color: ${colors.BRAND_PRIMARY};
`;

export default class FlightIntroduction extends Component {
  _toggleIsShowingOtherFlights = () => {
    this.setState(prevState => ({
      isShowingOtherFlights: !prevState.isShowingOtherFlights,
    }));
  };

  _selectFlight = () => {
    const { history } = this.props;
    const { pnr } = history.location.state;
    history.push('flight-change', {
      pnr,
    });
  };

  render() {
    // TODO: request for suggestion flight
    const flight = {};
    const { history } = this.props;
    const { pnr, hasSuggestion, user } = history.location.state;

    return hasSuggestion ? (
      <FlightChangeContainer>
        <Title>Alteração de voo</Title>
        <IllustrationContainer>
          <Illustration
            alt="Voo Cancelado ou Atrasado"
            src={ILUSTRACAO_VOO_CANCELADO}
          />
        </IllustrationContainer>
        <TextForUser>
          Olá{user && <Username> {user.name}</Username>}, tivemos uma mudança em
          seu voo, e sabemos que seu tempo é precioso. Fique tranquilo,{' '}
          <BoldText>você não terá que pagar nada a mais por isso</BoldText>.
          <br />
          <br />
        </TextForUser>
        <ReservationCode>
          Código da reserva: {pnr || user.recordLocator}
        </ReservationCode>
        <FlightSummary flight={flight} type={FLIGHT_STATUS.CANCELLED} />
        <BigBlueText>Veja o voo que sugerimos para você:</BigBlueText>
        <FlightSummary flight={flight} type={FLIGHT_STATUS.SUGGESTED} />
        <TextForUser hasSuggestion={hasSuggestion}>
          Todos os passageiros da reserva estão no voo sugerido. Abaixo, você
          pode confirmar nossa sugestão ou escolher um outro voo de acordo com a
          sua preferência:
        </TextForUser>
        <ActionsContainer hasSuggestion={hasSuggestion}>
          <Button
            success
            onClick={() => {
              history.push('flight-confirmation', {
                pnr,
                flight: {
                  //mock
                  flightNumber: '1234',
                  carrierCode: 'AD',
                  recordLocator: 'ABC123',
                  std: '2019-12-04T18:16:02.1709646-02:00',
                  staFinalDestination: '2019-12-04T18:16:02.1709722-02:00',
                  departureStation: 'VCP',
                  arrivalStationFinalDestination: 'CNF',
                },
              });
            }}
          >
            Confirmar voo
          </Button>
          <Button
            outlinePrimary
            onClick={() => {
              history.push('flight-change', {
                pnr,
              });
            }}
          >
            Escolher outro voo
          </Button>
        </ActionsContainer>
      </FlightChangeContainer>
    ) : (
      <FlightChangeContainer>
        <Title>Alteração de voo</Title>
        <IllustrationContainer>
          <Illustration
            alt="Voo Cancelado ou Atrasado"
            src={ILUSTRACAO_VOO_CANCELADO}
          />
        </IllustrationContainer>
        <TextForUser>
          Olá{user && <Username> {user.name}</Username>}, tivemos uma mudança em
          seu voo, e sabemos que seu tempo é precioso. Fique tranquilo,{' '}
          <BoldText>você não terá que pagar nada a mais por isso</BoldText>.
          <br />
          <br />
        </TextForUser>
        <ReservationCode>
          Código da reserva: {pnr || user.recordLocator}
        </ReservationCode>
        {flight.length && (
          <FlightSummary flight={flight} type={FLIGHT_STATUS.CANCELLED} />
        )}

        <TextForUser>
          <br />
          Para minimizar os possíveis impactos, abaixo você poderá escolher o
          seu novo voo de acordo com a sua preferência.
          <br />
          <br />
        </TextForUser>
        <ActionsContainer>
          <Button onClick={this._selectFlight} outlinePrimary>
            Escolher outro voo
          </Button>
        </ActionsContainer>
      </FlightChangeContainer>
    );
  }
}
